import { render } from "./TaskSettingsForm.vue?vue&type=template&id=e5d98f98"
import script from "./TaskSettingsForm.vue?vue&type=script&lang=js"
export * from "./TaskSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__